module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/photography-wideAngle-larger-mobile.07a85339.webp";